export default function observeStickyElement() {
	const el = document.querySelector(".sticky");
	if (el) {
		// Create a sentinel element right before the sticky element
		const sentinel = document.createElement("div");
		sentinel.style.position = "absolute";
		sentinel.style.height = "1px";
		sentinel.style.width = "1px";
		sentinel.style.pointerEvents = "none";

		// Insert sentinel before the sticky element
		el.parentElement.insertBefore(sentinel, el);

		const observer = new IntersectionObserver(
			([e]) => {
				// When sentinel is NOT visible, the sticky element is stuck
				el.classList.toggle("is-stuck", !e.isIntersecting);
			},
			{ threshold: [0], rootMargin: "0px" }
		);

		observer.observe(sentinel);
	}
}
